import React from "react";
import downArrow from "../assets/downArrow.png"; // Replace with the actual path to your image
import XboxBuy from "../assets/XboxBuy.png";
import XboxHover from "../assets/Xbox Hover.png";
import PsHover from "../assets/PS Hover.png";
import PcHover from "../assets/PC Hover.png";

import { useState } from "react";

import PsBuy from "../assets/PSBuy.png";
import OriginBuy from "../assets/OriginBuy.png";
import icon1 from "../assets/icon1.png"; // Replace with actual paths
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import icon4 from "../assets/icon4.png";
import icon5 from "../assets/icon5.png";
import icon6 from "../assets/icon6.png";

const HomeBuySection = () => {

  const [isHovered, setIsHovered] = useState(false);
  const [hovered, setHovered] = useState("");

  const handleNavigation = (platform) => {
    // Get the current referralCode from the URL or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get("referralCode");

    // Construct the destination URL
    const basePath = `/buy-${platform}-coins`;
    const destinationUrl = referralCode ? `${basePath}?referralCode=${referralCode}` : basePath;

    // Navigate to the destination URL
    window.location.href = destinationUrl;
  };

  return (
    <>
      {/* Buy Coins Section */}
      <div className="  bg-[#191919]  py-12 px-4 sm:px-6 lg:px-8 flex flex-col items-center space-y-6">
        {/* Title */}
        <strong style={{ fontFamily: "", fontWeight: 800 }} className="text-3xl sm:text-4xl font-monument lg:text-5xl font-bold text-primary text-center">
          CHOOSE YOUR PLATFORM
        </strong>

        {/* Down Arrow */}
        <img src={downArrow} alt="Arrow Down" className="h-7 mb-2" />

        {/* Platform Icons */}
        <div className="flex flex-row items-center justify-center lg:space-x-10 space-x-4">
          {/* Xbox */}
          <img
            src={isHovered ? XboxHover : XboxBuy}
            alt="Xbox"
            className="w-24 h-24 lg:w-44 lg:h-44 rounded-full border border-green-400 cursor-pointer"
            onClick={() => handleNavigation("xb")}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />

          {/* PlayStation */}
          <img
            src={hovered === "ps" ? PsHover : PsBuy}
            alt="PlayStation"
            className="w-24 h-24 sm:w-24 sm:h-24 lg:w-44 lg:h-44 rounded-full border border-blue-500 cursor-pointer"
            onClick={() => handleNavigation("ps")}
            onMouseEnter={() => setHovered("ps")}
            onMouseLeave={() => setHovered("")}
          />

          {/* PC */}
          <img
            src={hovered === "pc" ? PcHover : OriginBuy}
            alt="PC"
            className="w-24 h-24 sm:w-24 sm:h-24 lg:w-44 lg:h-44 rounded-full border border-[#FC8907] cursor-pointer"
            onClick={() => handleNavigation("pc")}
            onMouseEnter={() => setHovered("pc")}
            onMouseLeave={() => setHovered("")}
          />
        </div>
      </div>

      {/* Additional sections remain unchanged */}
      {/* Your existing sections for "Why Us?" and features */}

      <div className="lg:block hidden bg-[#191919]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 gap-x-12  place-items-start ">

          {/* Feature 1 */}
          <div className="flex items-center justify-center ml-72">
            <img src={icon1} alt="Ban Proof" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" />
            <div className="ml-4">
              <h3 className="text-primary text-lg font-inter font-bold mb-1">Safety Proof</h3>
              <p className="text-primary font-inter text-sm">
                Our Secure Trading Service provides a 7-day delivery
              </p>
              <p className="text-primary font-inter text-sm">
                guarantee for your peace of mind. </p>

            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex items-start">
            <img src={icon4} alt="Available 24/7" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" />
            <div className="ml-4">
              <h3 className="text-primary text-lg font-bold mb-1">Available 24/7</h3>
              <p className="text-primary font-inter text-sm">
                We're here for you 24/7, you can
              </p>
              <p className="text-primary font-inter text-sm">
                contact us through live chat,
              </p>
              <p className="text-primary font-inter text-sm">
                Twitter, Email, or Discord.
              </p>
            </div>
          </div>

          <div className="flex items-start  ml-72">
            <img src={icon5} alt="Ban Proof" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" />
            <div className="ml-4">
              <h3 className="text-primary text-lg font-inter font-bold mb-1">Cheapest Prices
              </h3>
              <p className="text-primary font-inter text-sm">
                We make sure to provide you


              </p>
              <p className="text-primary font-inter text-sm">
                the best value for your money.

              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex items-start">
            <img src={icon6} alt="Available 24/7" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" />
            <div className="ml-4">
              <h3 className="text-primary text-lg font-bold mb-1">Cashback</h3>
              <p className="text-primary font-inter text-sm">
                Earn cashback on every order
              </p>
              <p className="text-primary font-inter text-sm">
                and get discounts for future.                     </p>
            </div>
          </div>

          <div className="flex items-start  ml-72">
            <img src={icon3} alt="Ban Proof" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" />
            <div className="ml-4">
              <h3 className="text-primary text-lg font-inter font-bold mb-1">Order Tracking

              </h3>
              <p className="text-primary font-inter text-sm">
                You can track the current status


              </p>
              <p className="text-primary font-inter text-sm">
                of your order and stay updated.

              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex items-start">
            <img src={icon2} alt="Available 24/7" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" />
            <div className="ml-4">
              <h3 className="text-primary text-lg font-bold mb-1">Flash Delivery            </h3>
              <p className="text-primary font-inter text-sm">
                Our automated delivery system
              </p>
              <p className="text-primary font-inter text-sm">
                ensures order completion under
              </p>

              <p className="text-primary font-inter text-sm">
                20 Mins.
              </p>
            </div>
          </div>


        </div>
        {/*  */}



      </div>

      <div className="bg-[#191919]  text-white py-8  px-16 lg:hidden">
        {/* Feature 1 */}
        <div className="flex flex-row items-start justify-start mb-8">
          <img src={icon1} alt="Ban Proof" className="w-16 h-16 object-contain mt-5 mr-2" />
          <div className="text-left mt-0 ml-3">
            <h3 className="text-primary text-lg font-bold">Safety Proof</h3>
            <p className="text-sm text-primary">Our Secure Trading Service provides a 7-day delivery</p>
            <p className="text-sm text-primary">guarantee for your peace of mind.</p>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="flex flex-row items-center justify-start mb-8">
          <img src={icon4} alt="Available 24/7" className="w-16 h-16 object-contain" />
          <div className="text-left mt-2 ml-3">
            <h3 className="text-primary text-lg font-bold">Available 24/7</h3>
            <p className="text-sm text-primary">
              We're here for you 24/7, you can contact us through live chat, Twitter, Email, or Discord.
            </p>
          </div>
        </div>

        {/* Feature 3 */}
        <div className="flex flex-row items-start justify-start mb-8">
          <img src={icon5} alt="Cheapest Prices" className="w-16 h-16 object-contain" />
          <div className="text-left mt-0 ml-3">
            <h3 className="text-primary text-lg font-bold">Cheapest Prices</h3>
            <p className="text-sm text-primary">
              We make sure to provide you

              the best value for your money.
            </p>          </div>
        </div>

        {/* Feature 4 */}
        <div className="flex flex-row items-start justify-start mb-8">
          <img src={icon6} alt="Cashback" className="w-16 h-16 object-contain" />
          <div className="text-left mt-0 ml-3">
            <h3 className="text-primary text-lg font-bold">Cashback</h3>
            <p className="text-sm text-primary">Earn cashback on every order and get discounts for future.</p>
          </div>
        </div>



        {/* Feature 5 */}
        <div className="flex flex-row items-start justify-start mb-8">
          <img src={icon3} alt="Order Tracking" className="w-18 h-16 object-contain mr-5" />
          <div className="text-left mt-0 ml-3">
            <h3 className="text-primary text-lg font-bold">Order Tracking</h3>
            <p className="text-sm text-primary">You can track the current status of your order and stay updated.</p>
          </div>
        </div>

        {/* Feature 6 */}
        <div className="flex flex-row items-start justify-start mb-8">
          <img src={icon2} alt="Flash Delivery" className="w-16 h-16 object-contain" />
          <div className="text-left mt-0 ml-3">
            <h3 className="text-primary text-lg font-bold">Flash Delivery</h3>
            <p className="text-sm text-primary">Our automated delivery system ensures order completion under 20 mins.</p>
          </div>
        </div>
      </div>

    </>
  );
};

export default HomeBuySection;
